import { Component, Input, OnInit } from '@angular/core';
import { Client } from 'src/app/models/client';

@Component({
  selector: 'app-flow-of-money',
  templateUrl: './flow-of-money.component.html',
  styleUrls: ['./flow-of-money.component.scss']
})
export class FlowOfMoneyComponent implements OnInit {

  @Input() client?: Client;

  constructor() { }

  ngOnInit(): void {
  }

}
